module.exports = __webpack_public_path__ + "img/dashed_03.aa8ecfff.png";